module.exports = "../../../../platform/assets/pageMainIcon/business_jichudanganlei5.svg";